module.exports = __webpack_public_path__ + "img/logo.5f126a74.png";